import { render } from "./vpubNumberDisDvc.vue?vue&type=template&id=253892b4&scoped=true"
import script from "./vpubNumberDisDvc.vue?vue&type=script&lang=js"
export * from "./vpubNumberDisDvc.vue?vue&type=script&lang=js"

import "./vpubNumberDisDvc.vue?vue&type=style&index=0&id=253892b4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253892b4"]])

export default __exports__